import { useCallback, useMemo } from 'react';
import { Product, ProductCategory, ProductSearchQuery } from './types';
import { toQueryParams, useService } from '../common';

const API = {
    PRODUCT_AFFILIATE: '/product/affiliate',
    PRODUCT_CATEGORY: '/product/category',
    PRODUCT_SEARCH: '/product/search'
};

export const useProductService = () => {
    const service = useService();

    const searchProductList = useCallback((query: ProductSearchQuery): Promise<Product[]> => {
        return service.sendGetWithAuthorization(`${API.PRODUCT_SEARCH}${toQueryParams(query)}`)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    const getProductCategoryList = useCallback((): Promise<ProductCategory[]> => {
        return service.sendGetWithAuthorization(API.PRODUCT_CATEGORY)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    const getProductAffiliateUrl = useCallback((productId: string): Promise<{ url: string }> => {
        return service.sendGetWithAuthorization(`${API.PRODUCT_AFFILIATE}?id=${productId}`)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    return useMemo(() => ({
        searchProductList,
        getProductCategoryList,
        getProductAffiliateUrl,
    }), [searchProductList, getProductCategoryList, getProductAffiliateUrl]);
};